import { styled, component, spin } from '../../../utils/style';
import { Format, StyleColor } from '../../../utils/styles-constants';
import { Button } from '../../../components/Button/styles';
import { ParametersPageButton } from '../../ParametersPage/styles';

const DeleteButtonVariants: ({}) = {
	['Bar']: styled()(Button.extend, 'DeleteButton')`
		border-color: ${StyleColor.Red};
		color: ${StyleColor.Red};
		margin: 20px 5px;

		& > svg {
			height: 35px;
			width: 35px;
			fill: ${StyleColor.Red};
		}

		@media ${Format.Smartphone} {
			flex-basis: 25%;
		}

		@media (hover: hover) {
			&:hover {
				background-color: ${StyleColor.Red};
				border-color: ${StyleColor.Red};
				color: ${StyleColor.White};
			}
		}
	`,
	['Icon']: styled()(component.div, 'DeleteIcon')`
		cursor: pointer;
		& > svg {
			height: 30px;
			width: 30px;
		}`,
	['ParametersPage']: styled()(ParametersPageButton.extend, 'DeleteAllButton')`
		background-color: ${StyleColor.Red};
		border-color: ${StyleColor.Red};
		opacity: ${props => props.disabled ? 0.4 : 1};

		& > div {
			display: flex;
			flex-flow: row nowrap;
			align-items: center;
			width: 100%;

			& > svg {
				position: relative;
				left: 5px;
				height: 25px;
				width: 25px;
				animation: ${spin} 2s linear infinite;
			}

			& > span {
				margin: auto;
			}
		}

		@media (hover: hover) {
			&:hover {
				background-color: ${StyleColor.LightRed};
				border-color: ${StyleColor.LightRed};
				color: ${StyleColor.White};
			}
		}
	`
};

export { DeleteButtonVariants };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/DeleteButton/styles.ts